// Favorites Action Types
export const FavoritesTypes = {
  // Fetch favorites
  FETCH_FAVORITES_REQUEST: 'FAVORITES_FETCH_REQUEST',
  FETCH_FAVORITES_SUCCESS: 'FAVORITES_FETCH_SUCCESS',
  FETCH_FAVORITES_FAILURE: 'FAVORITES_FETCH_FAILURE',
  
  // Add video to favorites
  ADD_TO_FAVORITES_REQUEST: 'FAVORITES_ADD_VIDEO_REQUEST',
  ADD_TO_FAVORITES_SUCCESS: 'FAVORITES_ADD_VIDEO_SUCCESS',
  ADD_TO_FAVORITES_FAILURE: 'FAVORITES_ADD_VIDEO_FAILURE',
    // Remove video from favorites
  REMOVE_FROM_FAVORITES_REQUEST: 'FAVORITES_REMOVE_VIDEO_REQUEST',
  REMOVE_FROM_FAVORITES_SUCCESS: 'FAVORITES_REMOVE_VIDEO_SUCCESS',
  REMOVE_FROM_FAVORITES_FAILURE: 'FAVORITES_REMOVE_VIDEO_FAILURE',
  
  // Reorder videos in favorites
  REORDER_FAVORITES_REQUEST: 'FAVORITES_REORDER_REQUEST',
  REORDER_FAVORITES_SUCCESS: 'FAVORITES_REORDER_SUCCESS',
  REORDER_FAVORITES_FAILURE: 'FAVORITES_REORDER_FAILURE',
  
  // Toast notifications
  SHOW_TOAST: 'FAVORITES_SHOW_TOAST',
  
  // Playback actions
  LOAD_FAVORITES_FOR_PLAYBACK_REQUEST: 'FAVORITES_LOAD_FOR_PLAYBACK_REQUEST',
  LOAD_FAVORITES_FOR_PLAYBACK_SUCCESS: 'FAVORITES_LOAD_FOR_PLAYBACK_SUCCESS',
  LOAD_FAVORITES_FOR_PLAYBACK_FAILURE: 'FAVORITES_LOAD_FOR_PLAYBACK_FAILURE',
  SET_FAVORITES_PLAYBACK_INDEX: 'FAVORITES_SET_PLAYBACK_INDEX',
  NEXT_FAVORITES_VIDEO: 'FAVORITES_NEXT_VIDEO',
  PREVIOUS_FAVORITES_VIDEO: 'FAVORITES_PREVIOUS_VIDEO',
  TOGGLE_FAVORITES_AUTOPLAY: 'FAVORITES_TOGGLE_AUTOPLAY',
  CLEAR_FAVORITES_PLAYBACK: 'FAVORITES_CLEAR_PLAYBACK'
};
